/**
 * i18n configuration
 *
 * Sets up react-i18next with Serbian (default) and English.
 * Detects browser language and uses stored preference.
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import sr from './sr.json';
import en from './en.json';

const SUPPORTED_LANGUAGES = ['sr', 'en'];
const DEFAULT_LANGUAGE = 'en';
const STORAGE_KEY = 'astrolucy_language';

/**
 * Detect initial language from:
 * 1. localStorage (user's previous choice)
 * 2. Browser's navigator.language
 * 3. Default to Serbian
 */
function detectInitialLanguage(): string {
  // Check localStorage first (persisted preference)
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored && SUPPORTED_LANGUAGES.includes(stored)) {
    return stored;
  }

  // Detect from browser
  const browserLang = navigator.language?.split('-')[0]?.toLowerCase();
  if (browserLang && SUPPORTED_LANGUAGES.includes(browserLang)) {
    return browserLang;
  }

  // Default
  return DEFAULT_LANGUAGE;
}

const initialLanguage = detectInitialLanguage();

i18n.use(initReactI18next).init({
  resources: {
    sr: { translation: sr },
    en: { translation: en },
  },
  lng: initialLanguage,
  fallbackLng: DEFAULT_LANGUAGE,
  interpolation: {
    escapeValue: false, // React already escapes
  },
});

// Save language to localStorage when it changes
i18n.on('languageChanged', (lng) => {
  localStorage.setItem(STORAGE_KEY, lng);
});

export default i18n;
